import MOSTUSEDTECHSBYLANGUAGE from 'data/mantechcar24/most-used-techs-by-language.json';
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';

const MostUsedTechsByLanguage: React.FC = () => {
  return (
    <div>
      <StyledRecharts>
        <ResponsiveContainer height={400} width="99%" minWidth={500}>
          <BarChart data={MOSTUSEDTECHSBYLANGUAGE} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 20 }}
              tickFormatter={(tick) => {
                return `${tick}%`;
              }}
            ></XAxis>
            <YAxis
              type="category"
              dataKey="name"
              tickLine={false}
              width={120}
            />
            <Tooltip
              cursor={{ fill: '#ebe8df' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [value.toFixed(1) + '%', '']}
              wrapperClassName="tooltip-y"
            />
            <Bar dataKey="value" fill="fill" barSize={12} radius={5} />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default MostUsedTechsByLanguage;
